import { authApi } from '.';

export const signIn = async (usuario, password) => {
    const response = await authApi.post('/auth/sign-in', { usuario, password });
    return response;
};
